module.exports = __webpack_public_path__ + "static/media/pedido-encamino-orange.43347c16.svg";